import { Shipping } from 'models/auction/Shipping';
import { memo } from 'react';
import { List, SemanticICONS } from 'semantic-ui-react';
import { formatCurrency } from 'utils';

interface ShippingItemProps {
  shipping: Shipping;
}

function ShippingItem({ shipping }: ShippingItemProps) {
  const shippingWay = shipping.type;
  const description = shipping.description;

  let content = undefined;
  let icon: SemanticICONS | undefined = undefined;
  if (shippingWay === 'in_person') {
    content = description;
    icon = 'map';
  } else if (shippingWay === 'parcel') {
    content = `${formatCurrency(shipping.cost ?? 0)} (${description})`;
    icon = 'shipping';
  }

  return (
    <>
      {content && (
        <List.Item>
          <List.Icon name={icon} />
          <List.Content content={content} />
        </List.Item>
      )}
    </>
  );
}

export default memo(ShippingItem);
